import { render, staticRenderFns } from "./UserGroupMediaLibraryACL.vue?vue&type=template&id=4c16d34f&"
import script from "./UserGroupMediaLibraryACL.vue?vue&type=script&lang=ts&"
export * from "./UserGroupMediaLibraryACL.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupMediaLibraryACL.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports